import type { PaginationProps, TestDriveProps, TestDriveDetailProps } from 'modules/types'
import type { TestDriveHistory } from 'modules/testdrive/test-drive.dto'
import CONSTANT from 'modules/constant'
import { API, download, headers } from './api'

export const testDriveApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getTestDrive: builder.mutation<PaginationProps<TestDriveProps>, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_TEST_DRIVE,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData
      })
    }),
    getTestDriveList: builder.mutation<PaginationProps<TestDriveHistory>, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_TEST_DRIVE_LIST,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData
      })
    }),
    downloadTestDriveList: builder.mutation<PaginationProps<TestDriveHistory>, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_WEBADMIN_TEST_DRIVE_DOWNLOAD,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData,
        responseHandler: download,
        formData: true
      })
    }),
    getDetailTestDrive: builder.query<TestDriveDetailProps, number>({
      query: (id) => ({
        url: CONSTANT.URL_TEST_DRIVE_DETAIL + id,
        method: 'GET',
        headers: headers()
      })
    })
  })
})

export const {
  useGetTestDriveMutation,
  useGetTestDriveListMutation,
  useDownloadTestDriveListMutation,
  useGetDetailTestDriveQuery
} = testDriveApi
